<!-- UNA tarjeta. Antes eran dos, separadas por el gris del layout: el encabezado flotaba sobre su
     propio contenido y se leían como dos objetos distintos. -->
<div class="info-card cb-card">
  <!-- ── 1ª barra · identidad, el mes que manda, y las acciones ── -->
  <div class="card-header">
    <span class="card-icon"><i class="fa-solid fa-money-check-dollar"></i></span>
    <div class="cb-head-text">
      <h3>Cobranza</h3>
      <p>El dinero que entra y los comprobantes que lo respaldan.</p>
    </div>

    <div class="header-tags">
      <!-- Solo existe cuando hay algo. Y su conteo carga CON la pantalla, no al ir a mirar. -->
      <button
        *ngIf="attentionCount"
        pButton
        type="button"
        class="p-button-sm cb-alert"
        [label]="attentionCount + ' por atender'"
        icon="fa-solid fa-triangle-exclamation"
        (click)="openAttention()"
      ></button>

      <p-calendar
        [(ngModel)]="month"
        view="month"
        dateFormat="MM yy"
        [readonlyInput]="true"
        [showIcon]="true"
        (onSelect)="onMonthChange()"
        appendTo="body"
        styleClass="cb-month"
      ></p-calendar>

      <!-- Los reportes de Contabilidad del mes elegido. Cada opción aparece solo si el rol tiene su permiso. -->
      <app-reportes-contables [month]="monthParam"></app-reportes-contables>

      <button
        *appIfHasPermission="['payments', 'create']"
        pButton
        type="button"
        label="Cargar pagos del día"
        icon="fa-solid fa-file-arrow-up"
        class="p-button-sm"
        (click)="openBatch()"
      ></button>
    </div>
  </div>

  <!-- El embudo del mes. Es DATO, no control: por eso no cuenta como barra.
       Vive en el cascarón, así que cambiar de vista NO lo recrea ni lo vuelve a pedir. -->
  <div class="cb-funnel">
    <app-cobranza-funnel [summary]="summary" [loading]="loadingSummary" [view]="view"></app-cobranza-funnel>
  </div>

  <!-- ── 2ª barra · la vista. Los filtros y la búsqueda los pone cada vista dentro de su tabla. ── -->
  <div class="cb-toolbar">
    <div class="cb-seg" role="tablist" aria-label="Vistas de Cobranza">
      <button
        *ngFor="let v of visibleViews"
        type="button"
        role="tab"
        class="cb-seg-btn"
        [class.is-on]="view === v.key"
        [attr.aria-selected]="view === v.key"
        (click)="goTo(v)"
      >
        <i [class]="v.icon"></i>{{ v.label }}
      </button>
    </div>

    <!--
      El mapa de las seis pestañas. UNO para toda la pantalla, no uno por vista.

      Cada vista ya explica lo que enseña —las lentes de Avance llevan su nota, Cartera dice si el mes
      está abierto, las tablas de CENTRAL llevan su descripción, Conciliación avisa de que no aplica
      pagos—, así que repetirlo seis veces sería decir lo mismo con más tinta. Lo que NO está en
      ninguna parte es qué NO vas a encontrar en cada pestaña y en cuál está, y esa pregunta es
      comparativa: no se puede contestar desde dentro de una sola vista.
    -->
    <app-ayuda-cifra class="cb-mapa" titulo="Qué contesta cada pestaña">
      <p>Cada una responde <b>una</b> pregunta. Lo que no está en ella es a propósito, y aquí dice dónde sí está:</p>
      <ul>
        <li><b>Dinero</b> — el dinero que entró, pago por pago. Las facturas están en Comprobantes.</li>
        <li><b>Comprobantes</b> — los CFDI con sus archivos y complementos. Si están cobradas, en CENTRAL.</li>
        <li><b>CENTRAL</b> — qué se facturó este mes, en qué rubros y cuánto se cobró. Los saldos, en Cartera.</li>
        <li><b>Cartera</b> — cuánto se debe hoy por contrato. Las facturas que lo originaron, en CENTRAL.</li>
        <li><b>Avance</b> — cómo va la cobranza del mes y del año. <b>Sin contratos</b>: ese detalle es de Cartera.</li>
        <!--
          Decía «a quién se parece cada movimiento del banco» y no se entendía. Dentro de la vista
          basta con «le pone nombre a cada movimiento» porque la tabla está justo debajo; aquí se lee
          sin nada al lado, así que hay que decir literalmente qué entra y qué sale.
        -->
        <li>
          <b>Conciliación</b> — subes el estado de cuenta del banco y dice de qué cliente es cada depósito.
          <b>No registra ni aplica</b> nada.
        </li>
      </ul>
    </app-ayuda-cifra>

    <!-- «Por atender» no es una vista del segmentado: es una desviación a la que se entra por el
         aviso. Cuando se está dentro, la salida tiene que ser visible. -->
    <button
      *ngIf="view === 'atender'"
      pButton
      type="button"
      label="Volver a Dinero"
      icon="fa-solid fa-chevron-left"
      class="p-button-sm p-button-text"
      routerLink="/cobranza/dinero"
    ></button>

    <!--
      Los cuatro grupos, en la MISMA línea que el segmentado.

      Eran cuatro tarjetas de 90 px de alto que empujaban la tabla fuera de la pantalla para decir
      cuatro números. Aquí son fichas: conteo, nombre e importe en un renglón, y se ven como lo que
      son —botones que filtran— en vez de como tarjetas de resumen que resulta que además se pulsan.
    -->
    <div class="cb-grupos" *ngIf="view === 'atender' && attentionResumen" role="tablist" aria-label="Grupos de pagos por atender">
      <button
        *ngFor="let g of grupos"
        type="button"
        role="tab"
        class="cb-grupo"
        [ngClass]="'is-' + g.tono"
        [class.is-on]="grupo === g.key"
        [class.is-cero]="!conteo(g)"
        [attr.aria-selected]="grupo === g.key"
        (click)="verGrupo(g)"
      >
        <i [class]="g.icon" aria-hidden="true"></i>
        <b>{{ conteo(g) }}</b>
        <span>{{ g.label }}</span>
        <em>{{ monto(g) | currency: 'MXN' : 'symbol-narrow' : '1.0-0' }}</em>
      </button>
    </div>

    <!-- Los controles de la VISTA. El encabezado es de la pantalla; esta barra, de lo que se está
         mirando. Los tres de Comprobantes vivían en un encabezado que aquí no se pinta y quedaron
         inalcanzables (H-01): este es su sitio, no el de arriba. -->
    <div class="cb-view-tools" *ngIf="view === 'comprobantes'">
      <button
        *appIfHasPermission="['invoices', 'get-all']"
        pButton
        type="button"
        label="Central de Facturas"
        icon="fa-solid fa-file-arrow-down"
        class="p-button-sm p-button-outlined"
        (click)="openPendingExport()"
      ></button>
      <button
        *appIfHasPermission="['invoices', 'get-all']"
        pButton
        type="button"
        label="Reporte mensual"
        icon="fa-solid fa-file-excel"
        class="p-button-sm p-button-outlined"
        (click)="downloadMonthlyReport()"
        [loading]="!!invoices?.downloadingReport"
      ></button>
      <button
        pButton
        type="button"
        label="Carga masiva"
        icon="fa-solid fa-cloud-arrow-up"
        class="p-button-sm"
        (click)="openInvoiceUpload()"
      ></button>
    </div>
  </div>

  <!--
    ── El contenido de la vista ──

    Sale de la RUTA, no de un `*ngIf` en esta plantilla. Con los `*ngIf`, cambiar de vista navegaba a
    otra ruta hermana y Angular **destruía y recreaba esta pantalla entera**: el encabezado, el
    embudo y las fichas volvían a montarse y a pedir sus datos para acabar enseñando exactamente lo
    mismo. Con el outlet, lo único que se cambia es esto de abajo, que es lo único que cambia.
  -->
  <div class="cb-body">
    <router-outlet (activate)="onViewActivated($event)"></router-outlet>
  </div>

  <div class="cb-empty" *ngIf="!visibleViews.length && view !== 'atender'">
    <i class="fa-solid fa-lock" aria-hidden="true"></i>
    <p class="cb-empty-t">No tienes acceso a ninguna vista de Cobranza</p>
    <p class="cb-empty-b">Hacen falta los permisos de pagos o de facturas. Pídeselos a un administrador.</p>
  </div>
</div>

<!--
  El asistente de carga, en un modal grande.

  Era una pantalla aparte y se sacaba de Cobranza para volver a ella: cargar los pagos del día es
  una tarea DE esta pantalla, no un destino. En un modal, lo que se estaba mirando sigue detrás.

  La recuperación por dirección no se pierde: el lote viaja en `?carga=<uploadBatch>`, así que
  cerrar la pestaña entre registrar y aplicar sigue teniendo vuelta —que era el punto de la ruta.
-->
<p-dialog
  [(visible)]="showBatch"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [dismissableMask]="false"
  [showHeader]="false"
  [blockScroll]="true"
  styleClass="cb-batch-dialog"
  [style]="{ width: '80vw', maxWidth: '1400px' }"
  [contentStyle]="{ padding: '0' }"
  (onHide)="onBatchClosed()"
>
  <app-payment-batch-wizard
    *ngIf="showBatch"
    [uploadBatch]="batchToRecover"
    (batchCreated)="onBatchRegistered($event)"
    (finished)="closeBatch()"
  ></app-payment-batch-wizard>
</p-dialog>

<p-toast position="top-right"></p-toast>
